import type { FC } from 'react';
import { AccordionPaginationWrapper } from './AccordionPagination.styled';
import { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface AccordionPaginationProps {
   accordionData: any
}

const AccordionPagination: FC<AccordionPaginationProps> = ({accordionData}) => {
 
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 10;
   const [open, setOpen] = useState('');  // Track which accordion item is open

   // Function to toggle accordion item
   const toggle = (index:any) => {
      if (open === index) {
         setOpen('');  // Close the item if it's already open
      } else {
         setOpen(index);  // Open the new item
      }
   };

   // Calculate items to display based on current page
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const currentItems = accordionData.slice(indexOfFirstItem, indexOfLastItem);

   // Handle page change
   const paginate = (pageNumber:any) => setCurrentPage(pageNumber);

   // Calculate total pages
   const totalPages = Math.ceil(accordionData.length / itemsPerPage);


   return (
      <AccordionPaginationWrapper>
         <div>
            <Accordion open={open} toggle={toggle}>
            {currentItems.map((item:any, index:any) => (
               <AccordionItem key={index}>
                  <AccordionHeader targetId={String(index)}>
                     {item.header}
                  </AccordionHeader>
                  <AccordionBody accordionId={String(index)}>
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {item.body}
                     </SyntaxHighlighter>
                  </AccordionBody>
               </AccordionItem>
            ))}
            </Accordion>
            <br/>
            <Pagination>
               <PaginationItem>
                  <PaginationLink  onClick={() => paginate(1)} disabled={currentPage === 1} first/>
               </PaginationItem>
               <PaginationItem>
                  <PaginationLink onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} previous/>
               </PaginationItem>
               <PaginationItem>
                  <PaginationLink style={{cursor: 'text'}}><span>Page {currentPage} of {totalPages}</span></PaginationLink>
               </PaginationItem>
               <PaginationItem>
                  <PaginationLink onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} next/>
               </PaginationItem>
               <PaginationItem>
                  <PaginationLink  onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} last/>
               </PaginationItem>
            </Pagination>
         </div>
      </AccordionPaginationWrapper>
   )
};

export default AccordionPagination;